import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Card from 'react-bootstrap/Card';

import NotFound from 'features/common/errors/NotFound';
import { RequireSession } from 'layout';
import { Button } from 'ui';

/**
 * Session guard plus the desktop fallback for the govt-ID flows, which only run on a phone.
 * `onMount` lets the guard render through while the session token is being read out of the URL,
 * so a deep link is not bounced to `/session-expired` before it has a chance to bootstrap.
 */
const MobileOnlyFlow = ({
    session,
    updateSessionToken,
    updateReauthenticateSessionID,
    children,
}) => {
    const navigate = useNavigate();

    return (
        <RequireSession
            onMount
            session={session}
            updateSessionToken={updateSessionToken}
            updateReauthenticateSessionID={updateReauthenticateSessionID}
        >
            {isMobile ? (
                children
            ) : (
                <NotFound heading="This link can only be opened on a mobile device.">
                    <Card.Footer className="text-muted">
                        <Button
                            block
                            variant="primary"
                            onClick={() => {
                                navigate('/verification/links?bypass=true', { replace: true });
                            }}
                        >
                            Go Back
                        </Button>
                    </Card.Footer>
                </NotFound>
            )}
        </RequireSession>
    );
};

MobileOnlyFlow.propTypes = {
    session: PropTypes.object,
    updateSessionToken: PropTypes.func,
    updateReauthenticateSessionID: PropTypes.func,
    children: PropTypes.node,
};

export default MobileOnlyFlow;
